import React from 'react';
import AntCarousel, {
    CarouselProps as AntCarouselProps,
    CarouselRef,
} from 'antd/lib/carousel';

import { ControlButtons } from './ControlButtons';
import './Carousel.less';
import Styles from './Carousel.module.less';

type CarouselProps = AntCarouselProps & {
    myRef?: React.RefObject<CarouselRef>;
};

const Carousel = ({
    arrows = true,
    dots = true,
    ...props
}: CarouselProps): JSX.Element => {
    const carousel = props.myRef ?? React.createRef<CarouselRef>();
    const [currentlyShown, setCurrentlyShown] = React.useState(0);
    return (
        <div className={`vertical stretch-space-between ${Styles.container}`}>
            <AntCarousel
                prefixCls={Styles.aldCarousel}
                arrows={false}
                dots={dots}
                {...props}
                afterChange={current => {
                    setCurrentlyShown(current);
                    if (props.afterChange) {
                        props.afterChange(current);
                    }
                }}
                ref={carousel}
            />
            {arrows && (
                <ControlButtons
                    carousel={carousel}
                    current={currentlyShown}
                    totalCount={React.Children.count(props?.children)}
                />
            )}
        </div>
    );
};

export { Carousel };
export type { CarouselProps };
